<template>
    <li>
        <div class="steps-to-objective__activity"
             v-bind:class="{ 'steps-to-objective__activity--currently-editing' : showEditActivityForm, 'steps-to-objective__activity--completed': !showEditActivityForm && editing_index>=my_index }">
            <div class="steps-to-objective__activity-title">
                {{activity.name}}
            </div>
            <div v-if="editing_index>=my_index">
                <div class="steps-to-objective__activity-date" v-if="!showEditActivityForm">
                    <activity-date-display :color="objective.color" :activity="activity" :icon-class="iconClass"
                                           :subcategory-name="subcategoryName"/>
                </div>
                <a href="javascript:;"
                   class="button button--gray button--small steps-to-objective__edit-button"
                   @click="showEditActivityForm = true" v-if="!showEditActivityForm" v-translate>Edit activity</a>
                <div class="form steps-to-objective__define-activity" v-if="showEditActivityForm">
                    <input-field label="Describe your activity" type="textarea" :field="$v.activity.description"/>
                    <div class="form__group-category">
                        <div class="your-dates__category">
                            <span class="main-category-icon" :class="iconClass"></span>
                        </div>
                        <input-field label="Category" type="select2" :field="$v.activity.category"
                                     :options="categoryOptions"/>
                        <input-field label="Subcategory" type="select2" :field="$v.activity.subcategory"
                                     :alwaysfocus="true"
                                     :options="subcategoryOptions"/>
                    </div>
                    <input-field label="Your expected result" type="textarea" :field="$v.activity.expected_result"/>
                    <input-field label="How will you measure it" type="textarea" :field="$v.activity.measure"/>
                    <div v-if="activity.date == ''">
                        <div class="your-dates__date">
                            <div class="your-dates__date-title" v-translate>
                                When will you <strong>Do It?</strong>
                            </div>
                            <div class="your-dates__category">
                                <span class="main-category-icon" :class="iconClass"></span> {{subcategoryName}}
                            </div>
                            <div class="your-dates__date-strength">
                                <translate>Strength of your day:</translate>
                                <div class="date-strength date-strength--good">?</div>
                            </div>
                        </div>
                        <button @click="chooseDate()" class="button button--gray" type="button" v-translate>
                            Choose date
                        </button>
                    </div>
                    <div v-if="activity.date != ''">
                        <activity-date-display :color="objective.color" :activity="activity" :icon-class="iconClass"
                                               :subcategory-name="subcategoryName"/>
                        <button @click="chooseDate()" class="button button--gray button--small" type="button" v-translate>
                            Change date
                        </button>
                    </div>

                    <div class="form__action-buttons form__action-buttons--inline">
                        <a @click="submit()" href="javascript:;" class="button button--primary" v-translate>
                            Save and edit next activity
                        </a>
                        <!--<a href="javascript:;" class="button button--transparent"
                           @click="showEditActivityForm = false">Cancel</a>-->
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>
<script>
    import {mapActions} from "vuex";
    import {required} from 'vuelidate/lib/validators';
    import InputField from "./popups/InputField";
    import ChooseDate from "./popups/ChooseDate";
    import ActivityDateDisplay from "./ActivityDateDisplay";
    import ActivityClass from "../mixins/ActivityClass";
    import CategoryOptions from "../mixins/CategoryOptions";

    export default {
        name: 'add-activity-step-details',
        components: {InputField, ActivityDateDisplay},
        mixins: [ActivityClass, CategoryOptions],
        props: {
            parent_activity: {},
            objective: {},
            editing_index: {},
            my_index: {},
        },
        data() {
            return {
                activity: {},
                showEditActivityForm: true
            }
        },
        beforeMount() {
            this.activity = this.parent_activity
        },
        validations: {
            activity: {
                description: {},
                category: {required},
                subcategory: {required},
                expected_result: {required},
                measure: {required}
            }
        },
        methods: {
            submit: function () {
                this.$v.$touch()
                if (this.$v.$invalid || this.activity.date == '') {
                    console.log('invalid')
                } else {
                    this.showEditActivityForm = false
                    this.$emit('save')
                }
            },
            ...mapActions(['openPopup', 'setPopupPayload']),
            chooseDate: function () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.setPopupPayload(this.activity)
                    this.openPopup(ChooseDate)
                }
            }
        }
    }
</script>